
export default function BasicSpecs() {
  const specs = [
    { label: 'カード名', value: 'デポジット型クレジットカード' },
    { label: 'カードタイプ', value: 'デポジット型ショッピング専用クレジットカード' },
    { label: '年会費', value: '1,375円（税込）' },
    { label: '発行手数料', value: '1,100円（税込）※入会月の翌々月6日にお支払い' },
    { label: 'ポイント還元率', value: '0.5%（200円ごとに1ポイント）' },
    { label: 'ポイント名', value: 'ポイント' },
    { label: 'ポイント交換', value: '1ポイント=1円としてデジコのデジタルギフトに交換可能' },
    { label: '国際ブランド', value: 'Mastercard' },
    { label: 'デポジット（保証金）', value: '5万円〜200万円（デポジット額=利用限度額）' },
    { label: '申込条件', value: '18歳以上（高校生を除く）' },
    { label: '支払い方法', value: '口座振替 / コンビニ払い' },
    { label: 'リボ払い', value: '「みんなリボ」登録で毎月定額払い可能' },
    { label: 'ETCカード', value: '発行可能（年会費・発行費無料）※デポジット10万円以上が条件' },
    { label: 'Web会員サービス', value: '利用明細確認・ポイント交換申込が可能' },
    { label: '締め日・支払日', value: '毎月15日締め・翌月6日払い' },
    { label: '在留カード対応', value: '在留カードをお持ちの方も申込可能' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-8 text-center">
          デポジット型クレジットカードの基本スペック
        </h2>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <table className="w-full">
            <tbody>
              {specs.map((spec, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-[#F8F9FA]' : 'bg-white'}>
                  <td className="px-6 py-4 text-sm font-bold text-gray-700 border-b border-gray-200 w-1/3">
                    {spec.label}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 border-b border-gray-200">
                    {spec.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
